import { render } from "./LeaderboardView.vue?vue&type=template&id=5c7e4567"
import script from "./LeaderboardView.vue?vue&type=script&lang=js"
export * from "./LeaderboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__